// extracted by mini-css-extract-plugin
export default {"recaptcha":"index-module__recaptcha___Ok1oN"};